import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import AppErrorMessage from "../components/common/AppErrorMessage";
import LoadingSpinner from "../components/common/Loading";
import { VerifyOTPDTO } from "../dtos/doctor";
import { useLocation, useNavigate } from "react-router-dom";
import { verifyOTP } from "../features/auth/authSlice";

const OTPScreen = () => {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { state }: any = useLocation();

  const { loginPayload, isLoading, isOTPError, verifyMessage }: any =
    useAppSelector((state) => state.auth);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const obj: VerifyOTPDTO = {
      user_id: loginPayload?.data?.user_id,
      token: otp,
      exist: false,
      role: !state ? "clinic_owner" : state?.state,
    };
    dispatch(verifyOTP(obj))?.then((res) => {
      if (res?.payload?.success === true) {
        if (res?.payload?.data?.role == "staff") {
          localStorage?.setItem("authToken", JSON?.stringify(res?.payload?.data));
          navigate("/dashboard/staff-profile");
        } else {
          localStorage.setItem("authToken", JSON?.stringify(res?.payload?.data));
          navigate("/");
        }
      }
    });
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "80vh",
        }}
      >
        <Typography component="h1" variant="h5">
          OTP
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                type="number"
                label="OTP"
                name="otp"
                autoFocus
                onChange={(e) => setOtp(e?.target?.value)}
                InputProps={{
                  inputProps: {
                    min: 0,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              {isOTPError && <AppErrorMessage message={verifyMessage} />}
            </Grid>
            <Grid item xs={12}>
              {isLoading ? (
                <LoadingSpinner />
              ) : (
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mb: 2 }}
                >
                  Submit
                </Button>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default OTPScreen;
